/*默认图片*/
let defaultImg=require("@/assets/img/default.png");
let defaultLogo= require("../assets/logo/logo_red.png");
export {
  defaultImg,
  defaultLogo
}



// WEBPACK FOOTER //
// ./src/config/env.js